import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEmail, IsOptional, IsString } from 'class-validator';
import { DefaultStoreExposeGroup } from '../interface';
export class DefaultStoreMailerDto {
}
__decorate([
    ApiProperty({ type: () => String, example: 'info@gopparot.ai' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsEmail({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], DefaultStoreMailerDto.prototype, "from", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'info@gopparot.ai' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsEmail({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], DefaultStoreMailerDto.prototype, "replyTo", void 0);
//# sourceMappingURL=DefaultStoreMailerDto.js.map